import React from 'react';
import { Tag } from 'antd';
import { CheckOutlined, CloseOutlined, QuestionOutlined, MinusOutlined } from '@ant-design/icons';
import { colors } from '~/theme/colors.js';
import { $t } from '~/i18n.js';

const statusConfig = {
  open: {
    color: colors.blue,
    icon: <QuestionOutlined />,
    label: 'open',
  },
  accepted: {
    color: colors.green,
    icon: <CheckOutlined />,
    label: 'accepted',
  },
  tentative: {
    color: colors.gray,
    icon: <MinusOutlined />,
    label: 'tentative',
  },
  rejected: {
    color: colors.red,
    icon: <CloseOutlined />,
    label: 'rejected',
  },
};

export const ReservationStatusTag = ({ status }) => {
  const config = statusConfig[status] || statusConfig.open;

  return (
    <Tag color={config.color} icon={config.icon}>
      {$t(config.label)}
    </Tag>
  );
};
